'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { Typography } from '@/components/ui/typography';
import { DollarSign, Users } from 'lucide-react';

interface Plan {
  name: string;
}

interface CommissionsSectionProps {
  plan: Plan;
}

export function CommissionsSection({ plan }: CommissionsSectionProps) {
  const t = useTranslations('planDetails.emgoldexPlan.commissions');

  return (
    <SectionWrapper variant="default" padding="lg" className="relative bg-gray-50 dark:bg-gray-900/50">
      <div className="container">
        <div className="mb-12 text-center">
          <Typography variant="h2" className="mb-4">
            {t('title')}
          </Typography>
          <Typography variant="p" className="text-gray-600 dark:text-gray-400 max-w-4xl mx-auto">
            {t('description')}
          </Typography>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Referral Commission */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border-2 border-primary-200 dark:border-primary-800 hover:border-primary-400 dark:hover:border-primary-600 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
                <Users className="w-8 h-8 text-primary-600 dark:text-primary-400" />
              </div>
              <Typography variant="h3" className="text-2xl font-bold text-gray-900 dark:text-white">
                {t('referral.title')}
              </Typography>
            </div>
            <Typography variant="p" className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('referral.description')}
            </Typography>
          </div>

          {/* Table Split Commission */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border-2 border-blue-200 dark:border-blue-800 hover:border-blue-400 dark:hover:border-blue-600 transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                <DollarSign className="w-8 h-8 text-blue-600 dark:text-blue-400" />
              </div>
              <Typography variant="h3" className="text-2xl font-bold text-gray-900 dark:text-white">
                {t('tableSplit.title')}
              </Typography>
            </div>
            <Typography variant="p" className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('tableSplit.description')}
            </Typography>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}

